import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FieldsInterventionsToolbarComponent } from './fields-interventions-toolbar.component';
import {
  DxButtonModule,
  DxDateBoxModule,
  DxLoadPanelModule,
  DxSelectBoxModule,
  DxToolbarModule,
  DxValidationGroupModule,
  DxValidatorModule
} from 'devextreme-angular';

import {FieldsInterventionsNavigationModule} from '../fields-interventions-navigation/fields-interventions-navigation.module';


@NgModule({
  declarations: [FieldsInterventionsToolbarComponent],
    imports: [
        CommonModule,
        DxValidationGroupModule,
        DxToolbarModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxValidatorModule,
        DxLoadPanelModule,
        DxButtonModule,
        FieldsInterventionsNavigationModule
    ],
  exports: [FieldsInterventionsToolbarComponent]
})
export class FieldsInterventionsToolbarModule { }
